export default {
  heading: "Create New Password",
  intro: "Please create a new password for your EdCity account {id}.",
  submitBtn: "Submit",
  resetBtn: "Clear",
  closeBtn: "Close",
  completed:
    "Your password has been changed successfully.",
  recordNotFound: "Sorry, the page you requested cannot be found.<br>Please enter the URL again or try a different link. For assistance, please contact us at <a href=\"mailto:support{'@'}edcity.hk\" target=\"_top\">support{'@'}edcity.hk</a>.",
  backToHome: "Back to homepage",
  hasChanged: "You have set a new password by visiting this link already.  The link has expired.",
  expired: "The link has expired.",
  userNotFound: "As there is no record of your account in our system, please contact your School Administrator to check for your account.",
};
